import {Contribution} from "../../interfaces/contribution.interface";
import {CollectionViewer, DataSource} from "@angular/cdk/collections";
import {BehaviorSubject, Observable, of} from "rxjs";
import {catchError, finalize} from "rxjs/operators";
import {SolrService} from "../solr.service";
import {ContributionService} from "../contribution.service";

export class ContributionsDataSource implements DataSource<Contribution> {

	public contributionsSubject = new BehaviorSubject<Contribution[]>([]);
	private loadingSubject = new BehaviorSubject<boolean>(false);
	private countSubject = new BehaviorSubject<number>(0);
	public currentPageCountSubject = new BehaviorSubject<number>(0);

	public loading$ = this.loadingSubject.asObservable();
	public count$ = this.countSubject.asObservable();
	public currentPageCount$ = this.currentPageCountSubject.asObservable();

	constructor(private contributionService: ContributionService) {}

	connect(collectionViewer: CollectionViewer): Observable<Contribution[]> {
		return this.contributionsSubject.asObservable();
	}

	disconnect(collectionViewer: CollectionViewer): void {
		this.contributionsSubject.complete();
		this.loadingSubject.complete();
		this.countSubject.complete();
		this.currentPageCountSubject.complete();
	}

	list(filters = {}, orderBy = 'created_at', order = 'desc',
						pageNumber = 1, pageSize = 5) {

		this.loadingSubject.next(true);

		this.contributionService.index(filters, orderBy, order,
			pageNumber, pageSize).pipe(
			catchError(() => of([])),
			finalize(() => this.loadingSubject.next(false))
		)
			.subscribe((response: any) => {
				this.contributionsSubject.next(response.records);
        this.countSubject.next(response.total);
				this.currentPageCountSubject.next(response.records.length);
			});
	}

	getList() {
		return this.contributionsSubject.value;
	}
}
